module.exports = __webpack_public_path__ + "static/img/icon-STG.d91ac56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-STG.svg
// module id = 4XRi
// module chunks = 0